import * as React from 'react'
import { useState } from 'react'
import Model from '../../model/Model'
import { SettingsData } from '../../model/Settings'
import SettingsPanel from './SettingsPanel'

export function Settings (props: {appModel: Model}) {
  const [settings, setSettings] = useState(props.appModel.settingsData)

  const onSettingsChanged = (settingsData: SettingsData) => {
    props.appModel.updateSettings(settingsData)
    setSettings(props.appModel.settingsData)
  }

  return <SettingsPanel data={settings} changed={onSettingsChanged} />
}
